import { Plus } from 'lucide-react'
import { useState } from 'react'

import { Reveal } from '@/components/ui/Reveal'

import { SectionLabel } from './HowItWorks'

const faqs = [
  {
    a: "Yes, completely free. Players never pay a booking fee or commission on TurfChale. You only pay the turf's hourly rate, directly to the owner via the platform.",
    q: 'Is TurfChale free for players?',
  },
  {
    a: 'You can cancel up to 2 hours before your slot from the "My Bookings" section. Refund policies vary by turf — most offer full refunds for cancellations made 24 hours in advance.',
    q: 'How do I cancel a booking?',
  },
  {
    a: 'We support all major UPI apps (GPay, PhonePe, Paytm), debit and credit cards (Visa, Mastercard, RuPay), and wallets. All payments are processed securely through Razorpay.',
    q: 'What payment methods are supported?',
  },
  {
    a: 'Fill out the onboarding form below — it takes about 10 minutes. Our team will reach out within 24 hours to verify your turf, set up your dashboard, and get you live. Zero upfront cost.',
    q: 'How do I list my turf as an owner?',
  },
  {
    a: 'TurfChale is a Progressive Web App (PWA). You can install it directly from your browser — no app store needed. It works offline, sends push notifications, and looks and feels like a native app.',
    q: 'Does TurfChale work as an app?',
  },
  {
    a: 'Owners get 0% commission for the first 90 days. After that, a small platform fee applies depending on your plan. See the pricing page for full details.',
    q: 'What is the commission structure for owners?',
  },
]

export function FAQ() {
  const [open, setOpen] = useState<null | number>(0)

  return (
    <section className="max-w-7xl mx-auto px-6 md:px-12 py-20" id="faq">
      <SectionLabel>FAQ</SectionLabel>
      <Reveal delay={0.05}>
        <h2
          className="font-display font-bold leading-[1.1] tracking-tight mb-12"
          style={{
            color: 'var(--text)',
            fontSize: 'clamp(1.9rem,3.5vw,2.8rem)',
            letterSpacing: '-.5px',
            maxWidth: 520,
          }}
        >
          Common questions
        </h2>
      </Reveal>

      <div className="max-w-190 flex flex-col gap-2.5">
        {faqs.map((faq, i) => (
          <Reveal delay={i * 0.06} key={i}>
            <div
              className="rounded-2xl overflow-hidden transition-colors duration-200"
              style={{
                background: 'var(--bg3)',
                border: `1px solid ${open === i ? 'rgba(184,236,60,.35)' : 'var(--lime-line)'}`,
              }}
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 gap-4 text-left"
                onClick={() => setOpen(open === i ? null : i)}
              >
                <span className="text-[0.9rem] font-semibold" style={{ color: 'var(--text)' }}>
                  {faq.q}
                </span>
                <div
                  className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 border transition-transform duration-300"
                  style={{
                    borderColor: 'var(--lime-line)',
                    color: 'var(--lime)',
                    transform: open === i ? 'rotate(45deg)' : 'none',
                  }}
                >
                  <Plus size={14} />
                </div>
              </button>

              <div
                className="overflow-hidden transition-all duration-300 ease-in-out"
                style={{ maxHeight: open === i ? '200px' : '0' }}
              >
                <p
                  className="px-6 pb-5 text-[0.85rem] font-light leading-[1.75]"
                  style={{ color: 'var(--muted)' }}
                >
                  {faq.a}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  )
}
